// 개발 환경 (로컬)
const DEVELOPMENT_API_BASE_URL = 'http://localhost:8080';

// 배포 환경 (실제 서버)
const PRODUCTION_API_BASE_URL = 'https://api.clarte.store';



export const API_BASE_URL = PRODUCTION_API_BASE_URL;
